<script>
import { mapActions, mapGetters } from 'vuex'
import retryOnce from '@utils/retryOnce'
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isReportLoading: false,
      reportError: null,
    }
  },
  computed: {
    ...mapGetters([
      'getReport',
      'getReportDraft',
      'getReportDiff',
      'isAuthenticated',
    ]),
    report() {
      return this.getReport(this.id)
    },
    draft() {
      return this.getReportDraft
    },
  },
  watch: {
    id: {
      async handler(id) {
        // A newer id or teardown takes over, so this load stops retrying and
        // leaves the loading and error state alone.
        const isCurrent = () => this.id === id && !this._isDestroyed
        this.isReportLoading = true
        try {
          // A signed-out failure (expired session) won't recover on retry.
          await retryOnce(() => this.fetchReport(id), {
            shouldRetry: () => this.isAuthenticated && isCurrent(),
          })
        } catch (error) {
          if (!isCurrent()) {
            return
          }
          this.reportError = true
          throw Promise.reject(error)
        } finally {
          if (isCurrent()) {
            this.isReportLoading = false
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(['fetchReport']),
  },
  render() {
    const { report, draft, isReportLoading, reportError } = this
    return this.$scopedSlots.default({
      report,
      isReportLoading,
      reportError,
      draft,
      diff: this.getReportDiff,
    })
  },
}
</script>
